import { stepIds } from '../../flowDefinition/stepIds';


export const isTherePermanentResidenceStep = (steps) => {
  const residenceStep = steps.find(step => step.id === stepIds.permanentResidence);

  return !!residenceStep;
};
